import { Crop } from './ImageCropper';

export const ASPECT_RATIO = 16 / 9;
export const MIN_WIDTH = 1000;
export const MIN_HEIGHT = Math.round(MIN_WIDTH / ASPECT_RATIO);
export const CROP_16_9: Crop = {
  aspect: ASPECT_RATIO,
  position: { x: 0.5, y: 0.5 },
  zoom: 1,
};
